import React from 'react';
import { Typography } from '@mui/material';
import Navbar from '../Header/Navbar';
import Footer from '../Header/Footer';
import { Stack } from '@mui/system';
import { Circle } from '@mui/icons-material';
import { SectionList } from '../Sections/SectionElements';
const PrivacyPolicy = () => {
  return (
    <Stack gap={3}>
      <Navbar />
      <Stack sx={{
        width: '100%', alignItems: 'center', boxSizing: 'border-box', p: '20px',
        '& .section': {
          width: '100%', borderRadius: '16px', p: '16px', gap: 2,
          bgcolor: 'var(--color-bg-secondary)',
          boxSizing: 'border-box',
        },

        '& .heading': {
          fontSize: '32px', fontWeight: 'bold', paddingBottom: '4px',
          borderBottom: '1px solid var(--color-border)',
        },

        '& .content': {
          fontSize: '16px', color: 'var(--color-text-secondary)'
        }
      }} >
        <Stack sx={{width: '100%', maxWidth: '1080px', gap: 3, alignItems: 'flex-start'}} >
          <Stack className='section' style={{backgroundColor: 'transparent'}} >
            <Typography className='heading' >
              Privacy Policy
            </Typography>

            <Typography className='content' >
              Learn how we collect, use, and protect your information.
            </Typography>
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              01 Introduction
            </Typography>
            
            <Typography className="content" >
              Optigrit ("we," "us," or "our") respects the privacy of our users ("you" or "your"). This Privacy Policy describes how we collect, use, and disclose information about you when you use our platform ("Platform") and the services we offer (collectively, the "Services").
            </Typography>
          </Stack>
          
          <Stack className="section" >
            <Typography className="heading" >
              02 Information We Collect
            </Typography>

            <SectionList
              title={'We collect several types of information from and about users of our Services'}
              icon={<Circle sx={{fontSize: '10px'}} />}
              list={[
                {
                  label: `Account Information`, 
                  content: `When you create an account, we collect your name, email address, and any other information you choose to provide.`
                },
                {
                  label: `Usage Data`, 
                  content: `We collect information about how you use the Services, such as the features you access, the content you upload, and the time and date of your activity.`
                },
                {
                  label: `Log Data`, 
                  content: `We automatically collect standard log data when you use the Services, such as your IP address, browser type, device information, and referring website.`,
                },
                {
                  label: `Content Data`, 
                  content: `You may upload content to the Platform, such as videos, presentations, documents, and course materials. We store this content to provide the Services.`,
                },
              ]}
              
              renderItem={({label, content}) => (
                <Typography className='content' >
                  <strong>{label}:</strong> {content}
                </Typography>
              )}
            />
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              03 How We Use Your Information
            </Typography>

            <SectionList
              title={'We use the information we collect for various purposes, including:'}
              icon={<Circle sx={{fontSize: '10px'}} />}
              list={[
                `Provide and operate the Services`,
                `Create and maintain your account`,
                `Send you important information about the Services, including updates, security alerts, and support messages`,
                `Respond to your inquiries and support requests`,
                `Monitor and analyze use of the Services to improve our offerings`,
                `Personalize your experience with the Services`,
                `Enforce our Terms and Conditions`,
              ]}
              renderItem={item => (
                <Typography className='content' >
                  {item}
                </Typography>
              )}
            />
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              04 Sharing Your Information
            </Typography>

            <Typography className="content" >
              We may share your information with third-party service providers who help us operate the Services. These service providers are obligated to protect your information and use it only to provide the services we request. We may also disclose your information if we are required to do so by law or in the good faith belief that such disclosure is necessary to comply with legal process, protect the safety of others, or investigate fraud.
            </Typography>
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              05 Data Retention
            </Typography>

            <Typography className="content" >
              We will retain your information for as long as your account is active or as needed to provide you with the Services. We may also retain your information for a longer period as required by law or to comply with our legal obligations.
            </Typography>
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              06 Your Choices
            </Typography>

            <Typography className="content" >
              You can access and update your account information at any time. You can also choose to close your account by contacting us.
            </Typography>
          </Stack>
        
          <Stack className="section" >
            <Typography className="heading" >
              07 Security
            </Typography>

            <Typography className="content" >
              We take reasonable steps to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no internet transmission or electronic storage is completely secure.
            </Typography>
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              08 Children's Privacy
            </Typography>

            <Typography className="content" >
              Our Services are not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and you believe your child has provided us with personal information, please contact us.
            </Typography>
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              09 International Transfers
            </Typography>

            <Typography className="content" >
              Your information may be transferred to and processed in countries other than your own. These countries may have different data protection laws than your own country.
            </Typography>
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              10 Changes to this Privacy Policy
            </Typography>

            <Typography className="content" >
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on our Platform.
            </Typography>
          </Stack>

          <Stack className="section" >
            <Typography className="heading" >
              11 Contact Us
            </Typography>

            <Typography className="content" >
              If you have any questions about this Privacy Policy, please contact us at support@optigrit.com
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Footer />
    </Stack>
  );
};

export default PrivacyPolicy;
